import { AgentWithIcon, FormattedAgent, FormattedChat } from '../../../types/chat';
import { Chat as ChatType } from '../../../types';

/**
 * チャット情報をUIで使用する形式に整形します
 */
export const formatChats = (chats: ChatType[]): FormattedChat[] => {
  return chats.map(chat => ({
    id: chat.id,
    title: chat.title || chat.agent?.title || `チャット #${chat.id}`
  }));
};

/**
 * エージェント情報をUIで使用する形式に整形します
 * AIAgent型に合わせて形式変換
 */
export const formatAgents = (agents: AgentWithIcon[]): any[] => {
  return agents.map(agent => ({
    id: agent.id,
    title: agent.name || agent.title,
    description: agent.description || '',
    model_type: agent.model_type || 'chatgpt',
    prompt_template: agent.prompt_template || '',
    is_active: agent.is_active !== undefined ? agent.is_active : true,
    is_visible_in_sidebar: agent.is_visible_in_sidebar, // is_visible_in_sidebarを追加
    base_color: agent.base_color || '#FFC107',
    category: agent.category || 'その他',
    // 表示用拡張属性
    avatar: agent.avatar,
    capabilities: agent.capabilities || []
  }));
};

/**
 * エージェントのアイコンを含む拡張情報を作成します
 */
export const createAgentWithIcon = (agent: any): AgentWithIcon => {
  const modelIcons: {[key: string]: string} = {
    'chatgpt': '🤖',
    'claude': '🧠',
    'gemini': '✨'
  };
  
  return {
    ...agent,
    name: agent.title || 'Unknown Agent',
    avatar: `https://via.placeholder.com/40?text=${agent.title?.substring(0, 2) || 'AI'}`,
    capabilities: [],
    icon: modelIcons[agent.model_type || 'chatgpt'] || '🤖'
  };
};

/**
 * 新しいチャットかどうかをURLから判定します
 */
export const isNewChatFromURL = (pathname: string): boolean => {
  return pathname.endsWith('/chat/new');
};

/**
 * URLからエージェントIDを抽出します
 */
export const extractAgentIdFromURL = (search: string): number | null => {
  const params = new URLSearchParams(search);
  const agentIdParam = params.get('agentId');
  
  if (!agentIdParam) return null;
  
  const parsedId = parseInt(agentIdParam, 10);
  return !isNaN(parsedId) ? parsedId : null;
};

/**
 * クレジットの使用量が上限に達しているか判定します
 */
export const isTokenLimitReached = (
  user: any,
  orgTokenInfo: any
): boolean => {
  // 組織に所属している場合は組織のクレジット制限を確認
  if (user?.organization_id && orgTokenInfo) {
    return orgTokenInfo.is_limit_reached;
  }

  return false;
};
